var keyMirror = require('keymirror');

module.exports = keyMirror({
  AUTHENTICATION_CHANGED: null,
  EVENTS_UPDATED: null,
  EVENTS_TYPE_UPDATED: null,
  CHECKINS_UPDATED: null,
  CHECKED_IN: null,
  ENTRY_TICKET_CHECKED_IN: null,
});
